import messages from './messages';

const useSetQuotation = () => {
  return {
    setQuotationErrorMessages: messages,
  };
};

export default useSetQuotation;
